import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, FileText, Mountain, Crown, Plus } from 'lucide-react';
const DEFAULT_BONUSES = [{
  amount: '$250',
  label: 'per rep at launch'
}, {
  amount: '$250',
  label: 'per rep at 30 days'
}, {
  amount: '$250',
  label: 'per rep at 60 days'
}, {
  amount: '$250',
  label: 'per rep at 90 days'
}];
const ALT_BONUSES = [{
  amount: '$500',
  label: 'per rep at 15 days'
}, {
  amount: '$500',
  label: 'per rep at 45 days'
}];
export function ComparePage() {
  const [altBonus, setAltBonus] = useState(false);
  const bonuses = altBonus ? ALT_BONUSES : DEFAULT_BONUSES;
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans pb-24" data-id="element-581">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-16 px-6 md:px-12 max-w-5xl mx-auto text-center" data-id="element-582">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-583" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-584">
          <div className="inline-block px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-slate-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-585">
            Your Partnership Options
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight" data-id="element-586">
            Two Ways to Partner
          </h1>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed" data-id="element-587">
            A simple side-by-side of everything we discussed, so you can review
            the investment and share it with your team. Both packages run the
            full HIRE recruiting system. The difference is how much of the
            execution you want on your plate.
          </p>
        </motion.div>
      </section>

      {/* 2. CORE PACKAGES: ADVANTAGE vs SUMMIT */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-8" data-id="element-588">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch" data-id="element-589">
          {/* ADVANTAGE */}
          <div className="bg-slate-900/60 border border-[#7FE0C3]/40 rounded-2xl p-8 flex flex-col relative" data-id="element-590">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 px-4 py-1 bg-[#7FE0C3] text-[#163A5F] text-xs font-bold uppercase tracking-widest rounded-full" data-id="element-591">
              Most Teams Start Here
            </div>
            <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-592">
              <div className="p-2 bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 rounded-lg" data-id="element-593">
                <FileText className="w-6 h-6 text-[#7FE0C3]" data-id="element-594" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-595">Advantage</h2>
            </div>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-596">
              We build and own the recruiting system, and your team runs the
              interviews. A predictable hiring engine with full accountability.
            </p>

            {/* Pricing */}
            <div className="mb-6" data-id="element-597">
              <div className="flex items-end justify-between mb-5" data-id="element-598">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-599">
                  Build (One-Time)
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-600">$6,500</span>
              </div>
              <div className="flex items-end justify-between" data-id="element-601">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-602">
                  Total Monthly
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-603">$5,000</span>
              </div>
              <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-604">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-605">
                  What makes up the monthly
                </div>
                <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-606">
                  <li className="flex justify-between" data-id="element-607">
                    <span data-id="element-608">System fee</span>
                    <span data-id="element-609">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-610">
                    <span data-id="element-611">Campaign management</span>
                    <span data-id="element-612">$2,500</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-613">
              {/* Performance Bonuses */}
              <button type="button" onClick={() => setAltBonus(v => !v)} aria-pressed={altBonus} title="Performance bonuses" className="text-xs font-bold uppercase tracking-widest text-[#7FE0C3] mb-3 cursor-pointer hover:text-[#9aedd4] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7FE0C3]/40 rounded" data-id="element-614">
                Performance Bonuses
              </button>
              <ul className="space-y-1.5" data-id="element-615">
                {bonuses.map((bonus, i) => <li key={i} className="flex items-baseline text-sm" data-id="element-616">
                    <span className="font-semibold text-[#7FE0C3] mr-2 w-11 shrink-0" data-id="element-617">
                      {bonus.amount}
                    </span>
                    <span className="text-slate-400" data-id="element-618">{bonus.label}</span>
                  </li>)}
              </ul>
              <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-619">
                Tied to retention milestones, not just placement.
              </p>
            </div>

            {/* Value */}
            <div className="flex-1" data-id="element-620">
              <div className="text-sm font-bold text-white mb-3" data-id="element-621">
                What you get:
              </div>
              <ul className="space-y-2.5" data-id="element-622">
                {['Custom ATS, landing pages, and full funnel build', 'Active ad management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Two-day sales school for every new hire', 'Interview auditing and coaching to improve retention', 'Monthly recruiting review and ongoing consulting'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-623">
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-624" />
                    <span data-id="element-625">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-626">
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-627">
                <span className="text-white font-medium" data-id="element-628">Best for:</span> teams
                that want recruiting to finally be consistent and predictable,
                while keeping interviews and final decisions in-house.
              </p>
            </div>
          </div>

          {/* SUMMIT */}
          <div className="bg-slate-900/40 border border-amber-500/30 rounded-2xl p-8 flex flex-col relative" data-id="element-629">
            <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-630">
              <div className="p-2 bg-amber-500/10 border border-amber-500/20 rounded-lg" data-id="element-631">
                <Mountain className="w-6 h-6 text-amber-400" data-id="element-632" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-633">Summit</h2>
            </div>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-634">
              Everything in Advantage, plus a dedicated US-based recruiter who
              runs your interviews. Recruiting execution handled entirely for
              you.
            </p>

            {/* Pricing */}
            <div className="mb-6" data-id="element-635">
              <div className="flex items-end justify-between mb-5" data-id="element-636">
                <span className="text-xs text-amber-400 uppercase tracking-wider" data-id="element-637">
                  Build (One-Time)
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-638">$6,500</span>
              </div>
              <div className="flex items-end justify-between" data-id="element-639">
                <span className="text-xs text-amber-400 uppercase tracking-wider" data-id="element-640">
                  Total Monthly
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-641">$8,000</span>
              </div>
              <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-642">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-643">
                  What makes up the monthly
                </div>
                <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-644">
                  <li className="flex justify-between" data-id="element-645">
                    <span data-id="element-646">System fee</span>
                    <span data-id="element-647">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-648">
                    <span data-id="element-649">Campaign management</span>
                    <span data-id="element-650">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-651">
                    <span data-id="element-652">Corporate recruiter</span>
                    <span data-id="element-653">$3,000</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-654">
              {/* Performance Bonuses */}
              <button type="button" onClick={() => setAltBonus(v => !v)} aria-pressed={altBonus} title="Performance bonuses" className="text-xs font-bold uppercase tracking-widest text-amber-400 mb-3 cursor-pointer hover:text-amber-300 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/40 rounded" data-id="element-655">
                Performance Bonuses
              </button>
              <ul className="space-y-1.5" data-id="element-656">
                {bonuses.map((bonus, i) => <li key={i} className="flex items-baseline text-sm" data-id="element-657">
                    <span className="font-semibold text-amber-400 mr-2 w-11 shrink-0" data-id="element-658">
                      {bonus.amount}
                    </span>
                    <span className="text-slate-400" data-id="element-659">{bonus.label}</span>
                  </li>)}
              </ul>
              <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-660">
                Tied to retention milestones, not just placement.
              </p>
            </div>

            {/* Value */}
            <div className="flex-1" data-id="element-661">
              <div className="text-sm font-bold text-white mb-3" data-id="element-662">
                Everything in Advantage, plus:
              </div>
              <ul className="space-y-2.5" data-id="element-663">
                {['A dedicated US-based corporate recruiter representing your brand', 'Second-round interview execution handled for you', 'Candidate scheduling and follow-up', 'Full execution accountability'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-664">
                    <Check className="w-4 h-4 text-amber-400 mr-2 mt-0.5 shrink-0" data-id="element-665" />
                    <span data-id="element-666">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-667">
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-668">
                <span className="text-white font-medium" data-id="element-669">Best for:</span> teams
                whose leaders are too busy selling to interview, and want
                recruiting execution fully off their plate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. SHARED NOTE */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-20" data-id="element-670">
        <div className="p-5 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg" data-id="element-671">
          <p className="text-[#7FE0C3] text-center text-sm font-medium" data-id="element-672">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 4. LEADERSHIP ADD-ON */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-24" data-id="element-673">
        <div className="text-center mb-8" data-id="element-674">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-4" data-id="element-675">
            Optional Add-On
          </div>
          <h2 className="text-3xl font-bold text-white mb-3" data-id="element-676">
            Add Leadership to Either Package
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto leading-relaxed" data-id="element-677">
            Leadership is an optional add-on that layers onto Advantage or
            Summit. Run it in tandem with your main campaign, or ahead of it to
            put the right manager in place before you scale the team beneath
            them.
          </p>
        </div>

        {/* Visual: Advantage or Summit + Leadership */}
        <div className="flex flex-col sm:flex-row items-stretch justify-center gap-4 mb-10" data-id="element-678">
          <div className="flex-1 max-w-xs mx-auto sm:mx-0 bg-slate-900/40 border border-slate-700 rounded-xl p-5 text-center" data-id="element-679">
            <div className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-680">
              Core Package
            </div>
            <div className="text-white font-bold" data-id="element-681">Advantage or Summit</div>
            <div className="text-xs text-slate-500 mt-1" data-id="element-682">
              Recruits and ramps your reps
            </div>
          </div>
          <div className="flex items-center justify-center text-slate-500" data-id="element-683">
            <Plus className="w-6 h-6" data-id="element-684" />
          </div>
          <div className="flex-1 max-w-xs mx-auto sm:mx-0 bg-slate-900/40 border border-[#7FE0C3]/30 rounded-xl p-5 text-center" data-id="element-685">
            <div className="text-xs text-[#7FE0C3] uppercase tracking-wider mb-1" data-id="element-686">
              Add-On
            </div>
            <div className="text-white font-bold flex items-center justify-center" data-id="element-687">
              <Crown className="w-4 h-4 text-[#7FE0C3] mr-2" data-id="element-688" />
              Leadership
            </div>
            <div className="text-xs text-slate-500 mt-1" data-id="element-689">
              Recruits the managers who lead them
            </div>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-8" data-id="element-690">
          <div className="flex flex-col md:flex-row gap-10" data-id="element-691">
            <div className="flex-1" data-id="element-692">
              <div className="text-sm font-bold text-white mb-3" data-id="element-693">
                What you get:
              </div>
              <ul className="space-y-2.5" data-id="element-694">
                {['Targeted outreach to experienced operators and team leaders', 'Interviews handled for you', 'Vetted candidates passed to you for final approval only', 'Performance aligned to the leader and their team output'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-695">
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-696" />
                    <span data-id="element-697">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="w-full md:w-72 shrink-0 space-y-4 md:border-l md:border-slate-800 md:pl-10" data-id="element-698">
              <div className="flex items-end justify-between" data-id="element-699">
                <span className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-700">
                  Build (One-Time)
                </span>
                <span className="text-xl font-bold text-white" data-id="element-701">$7,500</span>
              </div>
              <p className="text-xs text-slate-500 -mt-2" data-id="element-702">
                Covers build and implementation of standard and leadership
                campaign.
              </p>
              <div className="flex items-end justify-between pt-2 border-t border-slate-800/50" data-id="element-703">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-704">
                  Monthly Management
                </span>
                <span className="text-xl font-bold text-white" data-id="element-705">$2,500</span>
              </div>
              <div className="flex items-end justify-between pt-2 border-t border-slate-800/50" data-id="element-706">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-707">
                  Performance
                </span>
                <span className="text-xl font-bold text-white" data-id="element-708">2.5%</span>
              </div>
              <p className="text-xs text-slate-500 -mt-2" data-id="element-709">
                Of revenue, capped at $15,000. Based on the leader's personal
                and team production combined.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. HOW TO CHOOSE */}
      <section className="px-6 md:px-12 max-w-3xl mx-auto" data-id="element-710">
        <div className="text-center mb-10" data-id="element-711">
          <h2 className="text-3xl font-bold text-white mb-3" data-id="element-712">How to choose</h2>
          <p className="text-slate-400" data-id="element-713">
            A quick way to land on the right fit for where your team is today.
          </p>
        </div>

        <div className="space-y-4" data-id="element-714">
          <div className="flex items-start bg-slate-900/30 border border-[#7FE0C3]/20 rounded-xl p-5" data-id="element-715">
            <FileText className="w-5 h-5 text-[#7FE0C3] mr-4 mt-0.5 shrink-0" data-id="element-716" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-717">
              <span className="text-white font-medium" data-id="element-718">Choose Advantage</span>{' '}
              if your team can run interviews well and you mainly need a
              recruiting system that produces consistent, qualified candidates.
            </p>
          </div>
          <div className="flex items-start bg-slate-900/30 border border-amber-500/20 rounded-xl p-5" data-id="element-719">
            <Mountain className="w-5 h-5 text-amber-400 mr-4 mt-0.5 shrink-0" data-id="element-720" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-721">
              <span className="text-white font-medium" data-id="element-722">Choose Summit</span> if
              interviewing is eating your leadership's time and you want a
              recruiter to handle execution end to end.
            </p>
          </div>
          <div className="flex items-start bg-slate-900/30 border border-[#7FE0C3]/20 rounded-xl p-5" data-id="element-723">
            <Crown className="w-5 h-5 text-[#7FE0C3] mr-4 mt-0.5 shrink-0" data-id="element-724" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-725">
              <span className="text-white font-medium" data-id="element-726">Add Leadership</span> to
              either package when you also need to recruit the managers and team
              leaders who will scale your operation.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-727">
          <p className="text-slate-500 text-sm max-w-xl mx-auto leading-relaxed" data-id="element-728">
            Most partners start with Advantage as the foundation, then add
            Summit for execution or Leadership for management hiring as their
            needs grow.
          </p>
        </div>
      </section>
    </div>;
}